// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2aV65Totm-nXSlM5_2Xbvu","spaceLeft":"_14SuYOqm1j5g5ctuSpYGFH","spaceBoth":"_3pVG_TfCv5xfhUyKTg5bBm","spaceRight":"_2tOYMV7Bi1AdIvTV2VXCkB","base":"ElnAcT5MtkHyg5fMA4haO","infoText":"HrHAqkKPDK2W6enTB6C8Y","status":"PXU5GxS7YgsDVQPVqO8Hq","statusDanger":"_1dDl9PMcx-2IdeuJ5lGjWk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisTransactionStatus.scss
// module id = 1237
// module chunks = 0